module.exports = __webpack_public_path__ + "img/Newbie_Sword_03_Warrior.a20711ce.png";